import moment from 'moment'

export default {
  methods: {
    sortDates (a, b) {
      return moment(b.dateOfPayment).format('YYYYMMDD') - moment(a.dateOfPayment).format('YYYYMMDD')
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/sortByDate.js